import { Button } from '@chakra-ui/react'
import { Link } from 'react-router'

import { useInsuranceParams } from '@/context/InsuranceParamsProvider'

import { useAuth } from '../../context/AuthContext'
import { DropdownMenuItem } from './MenuItem'

export const Poleas = () => {
  const { clearTriggerNewInsurance } = useInsuranceParams()
  const ctx = useAuth()
  const user = ctx?.user

  if (!user?.poleas?.poleasEnabled)
    throw new Error('Poleas not enabled')

  return <DropdownMenuItem label='Poleas'>
    <Button variant="ghost" as={Link} to='/Poleas/Imports'>Importované nabídky</Button>

    {user?.poleas?.enableImport && <>
      <Button variant="ghost" as={Link} to='/Poleas/Import'>Nový import nabídek</Button>
      <Button variant="ghost" as={Link} to='/Poleas/New' onClick={clearTriggerNewInsurance}>Nové poleas pojištění</Button>
    </>}

  </DropdownMenuItem>
}